import {Affix, Button, Col, Row} from 'antd'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import {ArrowLeftOutlined, MenuOutlined} from "@ant-design/icons";

const MobileSideBar = (props: any) => {
    const navigate = useNavigate()

    const { className } = props
    const goBack = () => {
        props.visible ? props.resetVisibility() : navigate(-1)
    }

    return (
        <Affix offsetBottom={0}>
            <div id="navbar" className={className}>
                <nav
                    style={{
                        background: 'var(--color-bg-surface)',
                        borderTop: '1px solid var(--color-bg-muted)',
                    }}
                >
                    <Row justify="space-around" align="middle" style={{ height: 70 }}>
                        <Col>
                            <Button
                                type="text"
                                size="large"
                                aria-label="Меню"
                                icon={<MenuOutlined style={{ fontSize: 24 }} />}
                                onClick={props.changeVisibility}
                            />
                        </Col>
                        <Col>
                            <Button
                                type="text"
                                size="large"
                                aria-label="Назад"
                                icon={<ArrowLeftOutlined style={{ fontSize: 24 }} />}
                                onClick={goBack}
                            />
                        </Col>
                    </Row>
                </nav>
            </div>
        </Affix>
    )
}

MobileSideBar.propTypes = {
    className: PropTypes.string.isRequired
}

export default MobileSideBar
